export const apiPath = '/v2/user_accesses';
const actionType = 'USER_ACCESSES';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
